/**
 * Normalise une Date en fixant l'heure à midi local pour éviter
 * tout décalage de jour lors du roundtrip JS → ISO (UTC) → MongoDB → JS.
 *
 * Exemple : new Date(2026, 4, 8, 0, 0) à Alger (UTC+1)
 *   .toISOString() → "2026-05-07T23:00:00.000Z"  ❌ jour précédent
 *
 * Avec normalizeDate(...) → midi local → ISO en milieu de journée UTC,
 * la date calendrier reste stable dans tous les fuseaux entre -11 et +12.
 */
export const normalizeDate = (d) => {
  if (!d) return null;
  const date = d instanceof Date ? new Date(d.getTime()) : new Date(d);
  if (isNaN(date.getTime())) return null;
  date.setHours(12, 0, 0, 0);
  return date;
};

/** Convertit en ISO string sans risque de décalage de jour, ou null. */
export const toSafeISO = (d) => {
  const norm = normalizeDate(d);
  return norm ? norm.toISOString() : null;
};

/**
 * Parse une date venant de l'API (ISO) et garantit qu'elle s'affichera
 * sur le même jour calendrier qu'en Algérie (UTC+1), peu importe
 * le fuseau horaire du navigateur de l'utilisateur.
 */
export const parseSafeDate = (d) => {
  if (!d) return new Date();
  
  if (typeof d === 'string' && d.length === 10 && d.indexOf('-') === 4) {
    const [y, m, day] = d.split('-');
    return new Date(y, m - 1, day, 12, 0, 0);
  }

  const date = new Date(d);
  if (isNaN(date.getTime())) return new Date();

  // On décale de +1 heure par rapport à UTC pour simuler l'heure d'Algérie (UTC+1)
  const utcMillis = date.getTime();
  const algeriaDate = new Date(utcMillis + 3600000);
  
  // On extrait le jour calendrier tel qu'il était en Algérie
  const y = algeriaDate.getUTCFullYear();
  const m = algeriaDate.getUTCMonth();
  const day = algeriaDate.getUTCDate();
  
  // On recrée une date locale à midi pour forcer l'affichage correct partout
  return new Date(y, m, day, 12, 0, 0);
};
